"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Feature = void 0;
var Feature;
(function (Feature) {
    Feature["tip"] = "tip";
    Feature["welcomeScreen"] = "welcomeScreen";
    Feature["drinkMinimum"] = "drinkMinimum";
    Feature["preorder"] = "preorder";
    Feature["orderCapacity"] = "orderCapacity";
    Feature["cashTipsOnly"] = "cashTipsOnly";
    Feature["menuOnly"] = "menuOnly";
    Feature["ticketIdRequired"] = "ticketIdRequired";
    Feature["preorderV2"] = "preorderV2";
})(Feature = exports.Feature || (exports.Feature = {}));
//# sourceMappingURL=feature.js.map